<template>
  <div
    :class="[
      'field--range',
      ...classObject,
    ]"
  >
    <InputfieldLabel
      :class="labelClass"
      :text="label"
      :for="fieldId"
    />
    <div class="fieldContent clr">
      <InputfieldDescription
        :text="description"
      />
      <div class="rangeInputWrap">
        <div
          :id="fieldId"
          ref="rangeInput"
        />
      </div>
    </div>
    <InputfieldNotes :text="notes" />
    <InputfieldErrors :items="parsedErrors" />
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldLabel from '@/components/forms/InputfieldLabel'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'
import noUiSlider from 'nouislider'

export default {
  name: 'InputfieldRange',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldLabel,
    InputfieldDescription,
    InputfieldNotes,
  },
  data: () => ({
    instance: null,
    baseConfig: {
      connect: true,
      start: [
        0,
        100,
      ],
      range: {
        'min': 0,
        'max': 100,
      },
      step: 10,
      tooltips: [
        true,
        true,
      ],
    },
  }),
  props: {
    config: {
      type: Object,
      required: false,
      default () {
        return {}
      },
    },
  },
  methods: {
    onChange (val) {
      this.clearErrors()

      this.$emit('input', {
        start: val[0],
        end: val[1],
      })
    },
  },
  watch: {
    value (val) {
      this.instance.set([
        val.start,
        val.end,
      ])
    },
  },
  mounted () {
    var config = Object.assign(this.baseConfig, this.config)

    this.instance = noUiSlider.create(this.$refs.rangeInput, config)
    this.instance.on('change', this.onChange)

    if (this.value && Object.keys(this.value).length) {
      this.instance.set([
        this.value.start,
        this.value.end,
      ])
    }
  },
}

</script>

<style lang="scss" scoped>

</style>
